import(/* webpackMode: "eager" */ "/app/src/app/events/page.tsx");
